import useServiceProjectFeatures from '@jira/servicedesk__service-project-features-store/src/useServiceProjectFeatures.tsx';
import {
	ENABLED,
	JSM_PROJECT_SUMMARY_NEW_EXPERIENCE,
} from '@jira/servicedesk__common/src/Enabled.tsx';

export const useNewExperienceFeatureEnabled = (): boolean => {
	const features = useServiceProjectFeatures();
	return features.data?.[JSM_PROJECT_SUMMARY_NEW_EXPERIENCE]?.status === ENABLED;
};
